import { Component } from '@angular/core';
import { EmployeeModuleMenuService } from '@app/modules/employees/services/employee-module-menu.service';
import { IndexView } from '@common/views';
import { MyTeamTable } from '@employees/services/tables/employee-table/my-team.table';

@Component({
    templateUrl: './my-team.template.html',
    styleUrls: ['./my-team.style.scss'],
})
export class MyTeamView extends IndexView {
    showEmployeeModuleMenu = false;

    constructor(
        public table: MyTeamTable,
        public employeeModuleMenuService: EmployeeModuleMenuService
    ) {
        super();

        this.table.reload();
    }

    onCreate(): void {}
}
